/**
 * Terminal stream handler — routes TERMINAL_RESULT into useTerminalStore.
 *
 * Mirrors browserStreamHandler's shape. Also installs the socket
 * reference on the store so runCommand has something to emit through.
 */
import type { Socket } from "socket.io-client";
import { EVENTS, type TerminalResultPayload } from "@bash/shared";
import { useTerminalStore } from "../terminalStore";

export function attachTerminalStreamHandler(socket: Socket): () => void {
  useTerminalStore.getState().setSocket(socket);

  const onResult = (payload: TerminalResultPayload) => {
    useTerminalStore.getState().onResult(payload);
  };
  socket.on(EVENTS.TERMINAL_RESULT, onResult);

  return () => {
    socket.off(EVENTS.TERMINAL_RESULT, onResult);
    // Don't clear the socket ref on cleanup — the next attach will
    // replace it via setSocket, and runtime callers may still hold
    // the store before reattach completes.
  };
}
